$(document).ready(function () {
    
    // NOTE: select2 is also used on the graduate list table filters. Those instances are initialized in init-graduate-list-table.js (RB)
    
    // Initialize gravity form selects
    $('.ginput_container_select .gfield_select, .ginput_container_time select').select2({
        minimumResultsForSearch: Infinity,
        placeholder: 'Select an option'
    });
    
    $('.name_prefix_select select, .name_suffix_select select, .ginput_container_date select').select2({
        minimumResultsForSearch: Infinity
    });
    
    $('.ginput_container .address_country select').select2({
        placeholder: 'Select a country',
        allowClear: true
    });
    
    $('.ginput_container .address_state select').select2({
        placeholder: 'Select a state',
        allowClear: true
    });
});